
  import { mapGetters } from 'vuex'
  export default {
    name: 'GamePage',
    computed: {
      ...mapGetters({
        mobileSlider: 'cms/mobileSlider'
      })
    },
    mounted() {
      if (this.isMobileOnly() && !this.mobileSlider?.is_visible) {
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'SliderContentMobile'
        })
      }
      if (this.isMobileOnly()) {
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'HeaderLogo'
        })
      }
      if (!this.isMobileOnly()) {
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 1,
          component_code: 'FooterLogo'
        })
      }
    }
  }
